import { formatCurrencyWithCode } from 'src/utils/formatters';
import { fechaCortaUtc } from './fechas';
import { normalizar } from './recorrido';
import { cajaDeObra, montosDeMovimiento, movimientosRecientesDeObras, otraMoneda } from './obraResumen';

export const MOVIMIENTOS_EN_CHAT = 3;

const PEDIDOS_DE_CAJA = ['ver la caja', 'ver caja', 'ver mi caja', 'mostrame la caja', 'mostrame mi caja', 'mi caja'];

// Escribirlo vale lo mismo que tocar el botón: la caja es la de la pantalla, no la caja chica del agente.
export const pideVerCaja = (texto) => PEDIDOS_DE_CAJA.includes(normalizar(texto));

export const MENSAJE_CAJA_VACIA =
  'Tu caja todavía está en cero: no cargaste ningún movimiento. Mandame el primero por WhatsApp, con una foto o un audio, y lo ves acá.';

const conEquivalente = (valores, moneda) => {
  const otra = otraMoneda(moneda);
  const principal = formatCurrencyWithCode(valores[moneda], moneda);
  return valores[moneda] === 0 && valores[otra] === 0 ? principal : `${principal} (${formatCurrencyWithCode(valores[otra], otra)})`;
};

const lineaDeMovimiento = (mov, moneda) => {
  const montos = montosDeMovimiento(mov);
  const detalle = [mov.categoria, mov.proveedor].filter(Boolean).join(' · ') || 'Sin categoría';
  const donde = [mov.obraNombre, fechaCortaUtc(mov.fecha)].filter(Boolean).join(' · ');
  const signo = mov.tipo === 'ingreso' ? '+' : '';
  return `${detalle}${donde ? `, ${donde}` : ''}: ${signo}${formatCurrencyWithCode(montos[moneda], moneda)}`;
};

// Lo que el chat responde a «Ver la caja»: el saldo de cada obra y lo último que se cargó, sin pasar por el modelo.
export const mensajeDeCaja = (obras = [], moneda = 'ARS') => {
  const recientes = movimientosRecientesDeObras(obras, MOVIMIENTOS_EN_CHAT);
  if (recientes.length === 0) return MENSAJE_CAJA_VACIA;

  const saldos = obras.map((obra) => `${obra.nombre}: ${conEquivalente(cajaDeObra(obra).saldo, moneda)}`);
  const partes = ['Así está tu caja hoy. Saldo de cada obra:', saldos.join('\n'), `Últimos movimientos:\n${recientes.map((m) => lineaDeMovimiento(m, moneda)).join('\n')}`];
  if (obras.some((o) => o?.truncado)) partes.push('Algún saldo es parcial: la caja completa tiene más movimientos.');
  return partes.join('\n\n');
};
